import { render, staticRenderFns } from "./newCustomerTarget.vue?vue&type=template&id=09981b34&scoped=true&"
import script from "./newCustomerTarget.vue?vue&type=script&lang=js&"
export * from "./newCustomerTarget.vue?vue&type=script&lang=js&"
import style0 from "./newCustomerTarget.vue?vue&type=style&index=0&id=09981b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09981b34",
  null
  
)

export default component.exports